/* ==========================================================================
   JuicyBite — all front-end behaviour lives in this one file.
   Nothing here is duplicated in jb.css. Safe to load on every page.
   ========================================================================== */
(function () {
  'use strict';

  var ready = function (fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  };

  /* ── 1. carousels ─────────────────────────────────────────────────────── */
  function initRails() {
    var rails = document.querySelectorAll('[data-jb-rail]');
    Array.prototype.forEach.call(rails, function (rail) {
      var id = rail.getAttribute('data-jb-rail');
      var prev = document.querySelector('[data-jb-prev="' + id + '"]');
      var next = document.querySelector('[data-jb-next="' + id + '"]');
      var step = function () {
        var card = rail.querySelector('.jb-jcard, .jb-rvc');
        return card ? card.offsetWidth + 20 : 280;
      };
      if (prev) {
        prev.addEventListener('click', function () {
          rail.scrollBy({ left: -step() * 2, behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          rail.scrollBy({ left: step() * 2, behavior: 'smooth' });
        });
      }
    });
  }

  /* ── 2. collection filters ────────────────────────────────────────────── */
  /* Chips toggle: tapping the active chip again clears that filter.          */
  function initFilters() {
    var grid = document.querySelector('[data-jb-grid]');
    if (!grid) { return; }

    var cards = grid.querySelectorAll('[data-jb-line]');
    var empty = document.querySelector('[data-jb-empty]');
    var title = document.querySelector('[data-jb-title]');
    var sub   = document.querySelector('[data-jb-sub]');
    var baseT = title ? title.textContent : '';
    var baseS = sub ? sub.textContent : '';
    var state = { line: 'all', filt: 'all' };

    function apply() {
      var shown = 0;
      Array.prototype.forEach.call(cards, function (c) {
        var okLine = state.line === 'all' || c.getAttribute('data-jb-line') === state.line;
        var okFilt = state.filt === 'all'
          || c.getAttribute('data-jb-meat') === state.filt
          || c.getAttribute('data-jb-cook') === state.filt;
        var ok = okLine && okFilt;
        c.style.display = ok ? 'flex' : 'none';
        if (ok) { shown += 1; }
      });

      if (empty) { empty.classList.toggle('is-on', shown === 0); }

      if (title) {
        if (state.line === 'all') {
          title.textContent = baseT;
        } else {
          var chip = document.querySelector('[data-jb-fline="' + state.line + '"]');
          title.textContent = chip ? chip.textContent.trim() : baseT;
        }
      }
      if (sub) {
        sub.textContent = (state.line === 'all' && state.filt === 'all')
          ? baseS
          : shown + (shown === 1 ? ' cut' : ' cuts');
      }
    }

    function bind(attr, key) {
      var btns = document.querySelectorAll('[' + attr + ']');
      Array.prototype.forEach.call(btns, function (b) {
        b.addEventListener('click', function () {
          var wasOn = b.classList.contains('is-on');
          Array.prototype.forEach.call(btns, function (x) { x.classList.remove('is-on'); });
          if (wasOn) {
            state[key] = 'all';
          } else {
            b.classList.add('is-on');
            state[key] = b.getAttribute(attr);
          }
          apply();
        });
      });
    }

    bind('data-jb-fline', 'line');
    bind('data-jb-ffilt', 'filt');

    /* deep link: /collections/all#line-kbbq */
    var hash = window.location.hash.replace('#line-', '');
    if (hash) {
      var target = document.querySelector('[data-jb-fline="' + hash + '"]');
      if (target) { target.click(); }
    }
    apply();
  }

  /* ── 3. PDP pack size + gallery ───────────────────────────────────────── */
  function initProduct() {
    var root = document.querySelector('[data-jb-product]');
    if (!root) { return; }

    var idInput = root.querySelector('[data-jb-varid]');
    var priceEl = root.querySelector('[data-jb-price]');
    var addBtn  = root.querySelector('[data-jb-add]');
    var packs   = root.querySelectorAll('[data-jb-variant]');

    function select(pack) {
      Array.prototype.forEach.call(packs, function (p) { p.classList.remove('is-on'); });
      pack.classList.add('is-on');
      if (idInput) { idInput.value = pack.getAttribute('data-jb-variant'); }
      if (priceEl) { priceEl.textContent = pack.getAttribute('data-jb-price-str'); }
      if (addBtn) {
        var avail = pack.getAttribute('data-jb-available') === 'true';
        addBtn.disabled = !avail;
        addBtn.textContent = avail
          ? 'Add to cart — ' + pack.getAttribute('data-jb-price-str')
          : 'Sold out';
      }
    }

    Array.prototype.forEach.call(packs, function (p) {
      if (p.hasAttribute('disabled')) { return; }
      p.addEventListener('click', function () { select(p); });
    });

    var first = root.querySelector('[data-jb-variant]:not([disabled])');
    if (first) { select(first); }

    var main = root.querySelector('[data-jb-main-image]');
    var thumbs = root.querySelectorAll('[data-jb-thumb]');
    Array.prototype.forEach.call(thumbs, function (t) {
      t.addEventListener('click', function () {
        if (!main) { return; }
        main.src = t.getAttribute('data-jb-thumb');
        Array.prototype.forEach.call(thumbs, function (x) { x.classList.remove('is-on'); });
        t.classList.add('is-on');
      });
    });
  }

  /* ── 4. cart drawer ───────────────────────────────────────────────────── */
  var Cart = (function () {
    var root = function () { return document.querySelector('[data-jb-currency]'); };

    function money(cents) {
      var n = Number(cents);
      if (!isFinite(n)) { n = 0; }
      var el = root();
      var code = el ? el.getAttribute('data-jb-currency') : 'USD';
      try {
        return (n / 100).toLocaleString(undefined, { style: 'currency', currency: code });
      } catch (e) {
        return '$' + (n / 100).toFixed(2);
      }
    }

    function open() { document.body.classList.add('jb-cart-open'); }
    function close() { document.body.classList.remove('jb-cart-open'); }

    function render(cart) {
      var body = document.querySelector('[data-jb-cart-body]');
      var total = document.querySelector('[data-jb-cart-total]');
      var counts = document.querySelectorAll('[data-jb-cart-count]');

      Array.prototype.forEach.call(counts, function (c) { c.textContent = cart.item_count; });
      if (total) { total.textContent = money(cart.total_price); }
      if (!body) { return; }

      if (!cart.items.length) {
        body.innerHTML = '<p class="jb-drawer__empty">Nothing in here yet.</p>';
        return;
      }

      var boxMap = {};
      var moreLabel = 'See what\u2019s inside';
      try {
        var mapEl = document.querySelector('[data-jb-boxmap]');
        if (mapEl) { boxMap = JSON.parse(mapEl.textContent) || {}; }
        var lblEl = document.querySelector('[data-jb-contents-label]');
        if (lblEl && lblEl.getAttribute('data-jb-contents-label')) {
          moreLabel = lblEl.getAttribute('data-jb-contents-label');
        }
      } catch (e) { boxMap = {}; }

      var html = '';
      cart.items.forEach(function (item, i) {
        var img = item.image
          ? '<img src="' + item.image + '" alt="" width="78" height="78">'
          : '<span class="jb-ci__ph"></span>';

        /* 박스 라인에는 구성품 펼치기를 붙입니다 */
        var inside = boxMap[item.handle];
        var expander = '';
        if (inside && inside.length) {
          var parts = inside.map(function (c) {
            var m = c.i
              ? '<span class="m"><img src="' + c.i + '" alt="" loading="lazy"></span>'
              : '<span class="m"></span>';
            return '<a class="jb-ci__it" href="' + (c.u || '#') + '">' + m +
              '<span class="n"></span><span class="q">\u00d7' + c.q + '</span></a>';
          }).join('');
          expander =
            '<button type="button" class="jb-ci__more" data-jb-ci-more aria-expanded="false">' +
            '<span class="lbl"></span><span class="car">\u25bc</span></button>' +
            '<div class="jb-ci__in" data-jb-ci-in hidden>' + parts + '</div>';
        }

        html += '<div class="jb-ci">' +
          '<div class="jb-ci__row">' + img +
          '<div><b></b><small></small></div>' +
          '<button class="jb-ci__rm" data-jb-cart-remove="' + (i + 1) + '" type="button">Remove</button>' +
          '</div>' + expander +
          '</div>';
      });
      body.innerHTML = html;

      /* set text via textContent so product titles can never inject markup */
      var rows = body.querySelectorAll('.jb-ci');
      cart.items.forEach(function (item, i) {
        if (!rows[i]) { return; }
        rows[i].querySelector('b').textContent = item.product_title;
        rows[i].querySelector('small').textContent =
          'Qty ' + item.quantity + ' \u00B7 ' + money(item.final_line_price);

        var lbl = rows[i].querySelector('.jb-ci__more .lbl');
        if (lbl) { lbl.textContent = moreLabel; }

        var inside = boxMap[item.handle];
        if (!inside) { return; }
        var names = rows[i].querySelectorAll('.jb-ci__it .n');
        inside.forEach(function (c, j) {
          if (names[j]) { names[j].textContent = c.t; }
        });
      });
    }

    function money0(cents) { return money(cents); }

    /* upsell rail — quantities mirror what is actually in the cart */
    /* 카트에 박스(번들)가 있는지 — 핸들 패턴으로 판별 */
    function isBoxItem(it) {
      var h = it.handle || '';
      return h.indexOf('the-meat-box-') === 0
          || h.indexOf('meat-box-') === 0
          || h.indexOf('meat-bite-') === 0
          || h.indexOf('chicken-bundle-') === 0
          || h.indexOf('chicken-bite-') === 0;
    }

    function cartHasBox(cart) {
      return (cart && cart.items ? cart.items : []).some(isBoxItem);
    }

    function getCart() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); });
    }

    /* 박스가 없으면 단품은 카트에 남아 있을 수 없음 — 남은 단품 줄을 전부 제거 */
    function enforceBoxRule(cart) {
      if (!cart || !cart.items || !cart.items.length) { return Promise.resolve(cart); }
      if (cartHasBox(cart)) { return Promise.resolve(cart); }

      var lines = [];
      cart.items.forEach(function (it, i) { if (!isBoxItem(it)) { lines.push(i + 1); } });
      if (!lines.length) { return Promise.resolve(cart); }

      /* 뒤 줄부터 지워야 줄 번호가 밀리지 않음 */
      lines.sort(function (a, b) { return b - a; });
      var chain = Promise.resolve();
      lines.forEach(function (ln) {
        chain = chain.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ line: ln, quantity: 0 })
          });
        });
      });
      return chain
        .then(getCart)
        .then(function (c) {
          flash('Box removed \u2014 singles went with it.');
          return c;
        })
        .catch(getCart);
    }

    function renderUpsell(cart) {
      var rows = document.querySelectorAll('[data-jb-up]');
      if (!rows.length) { return; }

      /* 박스가 없으면 애드온 잠금: 목록 숨김 + Add 버튼 비활성 */
      var unlocked = cartHasBox(cart);
      var wrap = document.querySelector('[data-jb-up-wrap]');
      if (wrap) { wrap.classList.toggle('is-locked', !unlocked); }

      var qty = {};
      cart.items.forEach(function (it) { qty[it.variant_id] = it.quantity; });

      var added = 0;
      Array.prototype.forEach.call(rows, function (row) {
        var id = Number(row.getAttribute('data-jb-up'));
        var price = Number(row.getAttribute('data-jb-up-price'));
        var q = qty[id] || 0;
        if (q) { added += q; }

        row.classList.toggle('is-in', q > 0);

        var line = row.querySelector('[data-jb-up-line]');
        if (line) {
          line.textContent = q
            ? '+' + money0(price) + ' \u00B7 ' + money0(price * q) + ' total'
            : '+' + money0(price);
        }

        var ctrl = row.querySelector('[data-jb-up-ctrl]');
        if (!ctrl) { return; }
        ctrl.innerHTML = q
          ? '<span class="jb-upq">'
            + '<button type="button" data-jb-up-set="' + (q - 1) + '" aria-label="Remove one">\u2212</button>'
            + '<span class="n">' + q + '</span>'
            + '<button type="button" data-jb-up-set="' + (q + 1) + '" aria-label="Add one">+</button></span>'
          : '<button type="button" class="jb-upc__one" data-jb-up-set="1">Add</button>';

        /* 잠금 상태면 이 행의 버튼들 비활성 */
        if (!unlocked) {
          Array.prototype.forEach.call(ctrl.querySelectorAll('button'), function (b) { b.disabled = true; });
        }
      });

      var label = document.querySelector('[data-jb-upcount]');
      if (label) {
        label.textContent = added
          ? added + (added === 1 ? ' single pack added' : ' single packs added')
          : '';
      }
    }

    function setQty(id, quantity) {
      var vid = Number(id);
      var qty = Number(quantity);

      /* 현재 카트에서 이 variant가 몇 개 있는지 확인 */
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (current) {
          var have = 0;
          (current.items || []).forEach(function (it) {
            if (Number(it.variant_id) === vid) { have += it.quantity; }
          });

          /* 카트에 없던 걸 담을 때(0 → N)는 add.js, 이미 있으면 change.js */
          if (have === 0 && qty > 0) {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: vid, quantity: qty }] })
            });
          }
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: String(vid), quantity: qty })
          });
        })
        .then(function (r) {
          if (!r.ok) { throw new Error('cart update failed'); }
          /* add.js는 담긴 아이템만, change.js는 전체 카트를 반환 → 항상 /cart.js로 새로 읽어 통일 */
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          render(cart);
          renderUpsell(cart);
          return cart;
        });
    }

    function refresh(thenOpen) {
      return getCart()
        .then(enforceBoxRule)
        .then(function (cart) {
          render(cart);
          renderUpsell(cart);
          if (thenOpen) { open(); }
          return cart;
        });
    }

    function add(id, qty) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(qty) || 1 }] })
      }).then(function (r) {
        if (!r.ok) { throw new Error('add failed'); }
        return refresh(true);
      });
    }

    function remove(line) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: 0 })
      }).then(function () { return refresh(false); });
    }

    var flashTimer = null;
    function flash(text) {
      var el = document.querySelector('[data-jb-added]');
      if (!el) { return; }
      el.textContent = text;
      el.classList.add('is-on');
      if (flashTimer) { clearTimeout(flashTimer); }
      flashTimer = setTimeout(function () {
        el.classList.remove('is-on');
        el.textContent = '';
      }, 4500);
    }

    return { open: open, close: close, add: add, remove: remove,
             refresh: refresh, setQty: setQty, flash: flash,
             hasBox: cartHasBox, renderUpsell: renderUpsell };
  }());

  window.JBCart = Cart;

  function initCart() {
    /* add to cart, from any quick-add form or the product page form */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest
        ? e.target.closest('[data-jb-quickadd], [data-jb-boxadd], #jb-add-form')
        : null;
      if (!form) { return; }
      e.preventDefault();

      var btn = form.querySelector('button[type="submit"]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding\u2026'; btn.disabled = true; }

      var idField = form.querySelector('[name="id"]');
      var qtyField = form.querySelector('[name="quantity"]');

      var isBox = form.hasAttribute('data-jb-boxadd');
      var boxName = '';
      if (isBox) {
        var h = form.closest('.jb-box');
        boxName = h ? h.querySelector('h3').textContent : 'Your box';
      }

      function reset() {
        if (btn) { btn.textContent = label; btn.disabled = false; }
      }

      function doAdd() {
        Cart.add(idField ? idField.value : null, qtyField ? qtyField.value : 1)
          .then(function () {
            reset();
            if (isBox) { Cart.flash(boxName + ' added'); }
          })
          .catch(function () {
            reset();
            form.removeAttribute('data-jb-quickadd');
            form.submit();
          });
      }

      if (isBox) { doAdd(); return; }

      /* 단품은 카트에 박스가 있을 때만 담깁니다 */
      Cart.refresh(false).then(function (cart) {
        if (Cart.hasBox(cart)) { doAdd(); return; }
        reset();
        Cart.flash('Single packs ship inside a box \u2014 add a box first.');
        Cart.open();
      }).catch(reset);
    });

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) { return; }

      if (t.closest('[data-jb-cart-open]')) {
        e.preventDefault();
        Cart.refresh(true);
        return;
      }
      if (t.closest('[data-jb-cart-close]')) {
        e.preventDefault();
        Cart.close();
        return;
      }
      /* 애드온 라인 칩 필터 */
      var chip = t.closest('[data-jb-upchip]');
      if (chip) {
        e.preventDefault();
        var want = chip.getAttribute('data-jb-upchip');
        var chips = document.querySelectorAll('[data-jb-upchip]');
        Array.prototype.forEach.call(chips, function (c) {
          c.classList.toggle('is-on', c === chip);
        });
        Array.prototype.forEach.call(document.querySelectorAll('[data-jb-upline]'), function (row) {
          var show = (want === 'all') || (row.getAttribute('data-jb-upline') === want);
          if (show) { row.removeAttribute('hidden'); } else { row.setAttribute('hidden', ''); }
        });
        return;
      }

      /* 구성품 펼치기 */
      var more = t.closest('[data-jb-ci-more]');
      if (more) {
        e.preventDefault();
        var panel = more.parentNode.querySelector('[data-jb-ci-in]');
        if (panel) {
          var open = panel.hasAttribute('hidden');
          if (open) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
          more.classList.toggle('is-open', open);
          more.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
        return;
      }

      var rm = t.closest('[data-jb-cart-remove]');
      if (rm) {
        e.preventDefault();
        Cart.remove(rm.getAttribute('data-jb-cart-remove'));
        return;
      }

      var set = t.closest('[data-jb-up-set]');
      if (set) {
        e.preventDefault();
        /* 박스가 없어 잠긴 상태면 애드온 담기 차단 */
        var lockedWrap = set.closest('[data-jb-up-wrap]');
        if (lockedWrap && lockedWrap.classList.contains('is-locked')) { return; }
        var row = set.closest('[data-jb-up]');
        if (!row) { return; }
        set.disabled = true;
        Cart.setQty(row.getAttribute('data-jb-up'), set.getAttribute('data-jb-up-set'))
          .catch(function () { set.disabled = false; });
      }
    });

    /* /cart 페이지 등 다른 경로로 박스만 빠진 카트를 들고 왔을 때도 로드 시 정리 */
    Cart.refresh(false);
  }

  /* ── 5. header menu drawer ────────────────────────────────────────────── */
  function initHeader() {
    var open = document.querySelectorAll('[data-jb-menu-open]');
    var close = document.querySelectorAll('[data-jb-menu-close]');
    if (!open.length) { return; }

    Array.prototype.forEach.call(open, function (b) {
      b.addEventListener('click', function () {
        document.body.classList.add('jb-menu-open');
      });
    });
    Array.prototype.forEach.call(close, function (b) {
      b.addEventListener('click', function () {
        document.body.classList.remove('jb-menu-open');
        document.body.classList.remove('jb-cart-open');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') { return; }
      document.body.classList.remove('jb-menu-open');
      document.body.classList.remove('jb-cart-open');
    });
  }


  /* ── 6. box builder (real-time cart sync) ─────────────────────────────────
     박스 담기는 <form data-jb-boxadd> submit으로 처리 → initCart의 전역 submit
     핸들러가 받아서 Cart.add()로 담고 헤더 카트 드로어를 바로 엽니다(애드온 포함).
     builder 화면 안에서는 사이즈 선택 UI와 "Add another (N in box)" 라벨만 관리하고,
     YOUR BOX 패널/ALL CUTS 그리드는 이 페이지에서 제거되어 관련 함수는 안전하게 가드됩니다.
     ------------------------------------------------------------------------- */
  function initBuilder() {
    var root = document.querySelector('[data-jb-builder]');
    if (!root) { return; }
    document.body.classList.add('jb-has-builder');

    var MIN = Number(root.getAttribute('data-jb-min') || 0) * 100;
    var line = 'all';
    var cart = { items: [], item_count: 0, total_price: 0 };

    function money(cents) {
      var n = Number(cents);
      if (!isFinite(n)) { n = 0; }
      try { return (n / 100).toLocaleString(undefined, { style: 'currency', currency: 'USD' }); }
      catch (e) { return '$' + (n / 100).toFixed(2); }
    }

    /* ---- read track options from the hidden DOM ---- */
    function readOpts(track) {
      var out = [];
      Array.prototype.forEach.call(track.querySelectorAll('[data-jb-opt]'), function (n) {
        var items = [];
        Array.prototype.forEach.call(n.querySelectorAll('[data-jb-item]'), function (i) {
          items.push({
            title: i.getAttribute('data-title'),
            qty: Number(i.getAttribute('data-qty')) || 0,
            img: i.getAttribute('data-img')
          });
        });
        out.push({
          id: n.getAttribute('data-id'),
          url: n.getAttribute('data-url') || '',
          variant: n.getAttribute('data-variant'),
          size: n.getAttribute('data-size'),
          packs: Number(n.getAttribute('data-packs')) || 0,
          price: Number(n.getAttribute('data-price')) || 0,
          compare: Number(n.getAttribute('data-compare')) || 0,
          available: n.getAttribute('data-available') === 'true',
          contents: items
        });
      });
      return out;
    }

    function uniq(list) {
      var seen = {}, out = [];
      list.forEach(function (v) { if (!seen[v]) { seen[v] = 1; out.push(v); } });
      return out;
    }

    /* variant meta lookup so we can label cart lines as box vs single */
    var variantMeta = {};   /* id -> {packs, contents, isBox, title, price, compare} */

    function registerTrack(track) {
      var opts = readOpts(track);
      var titleEl = track.querySelector('h3');
      var trackTitle = titleEl ? titleEl.textContent : 'Box';
      opts.forEach(function (o) {
        variantMeta[o.id] = {
          isBox: true,
          packs: o.packs,
          price: o.price,
          compare: o.compare,
          contents: o.contents,
          title: trackTitle + ' \u00b7 ' + o.variant + ' \u00b7 ' + o.size
        };
      });
      track._opts = opts;
    }

    function registerSku(card) {
      var id = card.getAttribute('data-jb-sku');
      variantMeta[id] = {
        isBox: false,
        packs: 1,
        price: Number(card.getAttribute('data-jb-price')) || 0,
        compare: Number(card.getAttribute('data-jb-price')) || 0,
        title: card.getAttribute('data-jb-title'),
        img: card.getAttribute('data-jb-img')
      };
    }

    /* ---- cart helpers ---- */
    function qtyInCart(variantId) {
      var q = 0;
      cart.items.forEach(function (it) { if (String(it.variant_id) === String(variantId)) { q += it.quantity; } });
      return q;
    }
    function lineOf(variantId) {
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].variant_id) === String(variantId)) { return i + 1; }
      }
      return 0;
    }

    function fetchCart() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { cart = c; return c; });
    }

    function syncHeader() {
      var counts = document.querySelectorAll('[data-jb-cart-count]');
      Array.prototype.forEach.call(counts, function (c) { c.textContent = cart.item_count; });
      var total = document.querySelector('[data-jb-cart-total]');
      if (total) { total.textContent = money(cart.total_price); }
      var body = document.querySelector('[data-jb-cart-body]');
      if (body) {
        if (!cart.items.length) {
          body.innerHTML = '<p class="jb-drawer__empty">Nothing in here yet.</p>';
        } else {
          body.innerHTML = cart.items.map(function (item, i) {
            var img = item.image
              ? '<img src="' + item.image + '" alt="" width="54" height="54">'
              : '<span class="jb-ci__ph"></span>';
            return '<div class="jb-ci" data-jb-line="' + (i + 1) + '">' + img +
              '<div><b></b><small></small></div>' +
              '<button class="jb-ci__rm" data-jb-cart-remove="' + (i + 1) + '" type="button">Remove</button></div>';
          }).join('');
          var rows = body.querySelectorAll('.jb-ci');
          cart.items.forEach(function (item, i) {
            if (!rows[i]) { return; }
            rows[i].querySelector('b').textContent = item.product_title;
            rows[i].querySelector('small').textContent = 'Qty ' + item.quantity + ' \u00B7 ' + money(item.final_line_price);
          });
        }
      }
      if (window.JBCart && window.JBCart.renderUpsell) { window.JBCart.renderUpsell(cart); }
    }

    var busy = false;
    function setBusy(v) { busy = v; root.classList.toggle('jb-bld--busy', v); }

    function cartAdd(id, qty) {
      setBusy(true);
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(qty) || 1 }] })
      }).then(function (r) { if (!r.ok) { throw new Error('add'); } return fetchCart(); })
        .then(function () { draw(); syncHeader(); setBusy(false); })
        .catch(function () { setBusy(false); });
    }

    function cartSet(id, quantity) {
      setBusy(true);
      var vid = Number(id);
      var qty = Number(quantity);
      var have = qtyInCart(vid);
      var req;
      if (have === 0 && qty > 0) {
        /* 카트에 없던 걸 담기 → add.js */
        req = fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: vid, quantity: qty }] })
        });
      } else {
        /* 이미 있는 것의 수량 조정(0이면 제거) → change.js */
        req = fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: String(vid), quantity: qty })
        });
      }
      return req
        .then(function (r) { if (!r.ok) { throw new Error('cart update'); } return fetchCart(); })
        .then(function () { draw(); syncHeader(); setBusy(false); })
        .catch(function () { setBusy(false); });
    }

    /* ---- draw a track ---- */
    function drawTrack(track) {
      var opts = track._opts || [];
      if (!opts.length) { return; }

      var variants = uniq(opts.map(function (o) { return o.variant; }));
      var curVar = track.getAttribute('data-cur-variant') || variants[0];
      if (variants.indexOf(curVar) === -1) { curVar = variants[0]; }
      track.setAttribute('data-cur-variant', curVar);

      var sized = opts.filter(function (o) { return o.variant === curVar; });
      var sizes = uniq(sized.map(function (o) { return o.size; }));
      var curSize = track.getAttribute('data-cur-size') || sizes[0];
      if (sizes.indexOf(curSize) === -1) { curSize = sizes[0]; }
      track.setAttribute('data-cur-size', curSize);

      var opt = sized.filter(function (o) { return o.size === curSize; })[0] || sized[0];

      var varBox = track.querySelector('[data-jb-varis]');
      if (varBox) {
        varBox.innerHTML = variants.map(function (v) {
          return '<button type="button" class="jb-vari' + (v === curVar ? ' is-on' : '') +
            '" data-jb-setvar="' + v + '">' + v + '</button>';
        }).join('');
        /* variant가 1개뿐이면(치킨바이트/미트바이트 공통) 탭 줄 자체를 숨김 */
        varBox.style.display = variants.length > 1 ? '' : 'none';
      }

      /* 사이즈 버튼: 가짜 정가 대신 "가장 작은 사이즈 대비 팩당 낙폭"을 씁니다.
         사이트 안에 실재하는 값끼리 비교하므로 근거가 검증 가능합니다. */
      var basePerPack = 0;
      sized.forEach(function (o) {
        if (!o.packs) { return; }
        var pp = o.price / o.packs;
        if (pp > basePerPack) { basePerPack = pp; }
      });

      track.querySelector('[data-jb-szs]').innerHTML = sizes.map(function (sz) {
        var o = sized.filter(function (x) { return x.size === sz; })[0];
        var isNumericSize = /^\d+$/.test(sz);
        var label = isNumericSize ? (o.packs + ' Packs') : sz;
        var note = '';
        if (o.packs && basePerPack > 0) {
          var drop = Math.round((1 - (o.price / o.packs) / basePerPack) * 100);
          note = drop > 0
            ? '<i>\u2212' + drop + '% / PACK</i>'
            : '<i class="jb-sz__base">START HERE</i>';
        }
        return '<button type="button" class="jb-sz' + (sz === curSize ? ' is-on' : '') +
          '" data-jb-setsize="' + sz + '"><b>' + label + '</b>' + note + '</button>';
      }).join('');

      var moreLink = track.querySelector('[data-jb-more]');
      if (moreLink) {
        if (opt.url) {
          moreLink.setAttribute('href', opt.url);
          moreLink.hidden = false;
        } else {
          moreLink.hidden = true;
        }
      }

      var body = track.querySelector('[data-jb-contents]');
      body.innerHTML = '<div class="jb-mixhead"><b>What\u2019s inside</b><span>' +
        opt.packs + ' packs</span></div><div class="jb-tiles">' +
        opt.contents.map(function (c) {
          var m = c.img
            ? '<span class="jb-tile__m"><img src="' + c.img + '" alt=""></span>'
            : '<span class="jb-tile__m jb-tile__ph">Photo needed</span>';
                              return '<div class="jb-tile">' + m.replace('</span>', '<span class="jb-tile__n">' + c.qty + '</span></span>') +
            '<span class="jb-tile__t"><span></span></span></div>';
        }).join('') + '</div>';
                  var tiles = body.querySelectorAll('.jb-tile__t');
      opt.contents.forEach(function (c, i) {
        if (!tiles[i]) { return; }
        var inner = tiles[i].firstElementChild || tiles[i];
        inner.textContent = c.title;
      });
      requestAnimationFrame(function () {
        Array.prototype.forEach.call(tiles, function (t) {
          var inner = t.firstElementChild;
          if (!inner) { return; }
          t.classList.remove('is-scroll');
          inner.style.removeProperty('--shift');
          var over = inner.scrollWidth - t.clientWidth;
          if (over > 2) {
            t.classList.add('is-scroll');
            inner.style.setProperty('--shift', '-' + (over + 8) + 'px');
          }
        });
      });

      track.querySelector('[data-jb-price]').textContent = money(opt.price);
      var wasEl = track.querySelector('[data-jb-was]');
      if (wasEl) { wasEl.textContent = ''; }
      var pctEl = track.querySelector('[data-jb-pct]');
      if (pctEl) { pctEl.textContent = ''; }
      var eachEl = track.querySelector('[data-jb-each]');
      if (eachEl) {
        var unitMode = eachEl.getAttribute('data-jb-unit') || 'full';
        if (unitMode === 'ship' || !opt.packs) {
          eachEl.textContent = 'Free frozen shipping included';
        } else {
          eachEl.textContent = money(opt.price / opt.packs) + ' per pack \u00b7 includes frozen shipping';
        }
      }

      /* hidden form input이 실제로 담길 variant id를 항상 들고 있게 갱신 */
      var varInput = track.querySelector('[data-jb-trackvar]');
      if (varInput) { varInput.value = opt.id; }

      /* Add button reflects quantity already in cart */
      var addBtn = track.querySelector('[data-jb-trackadd]');
      var inCart = qtyInCart(opt.id);
      addBtn.disabled = !opt.available;
      if (!opt.available) {
        addBtn.textContent = 'Sold out';
      } else if (inCart > 0) {
        addBtn.textContent = 'Add another \u2014 ' + money(opt.price) + ' (' + inCart + ' in box)';
      } else {
        addBtn.textContent = 'Add \u2014 ' + money(opt.price);
      }
      track._curOpt = opt;
    }

    /* ---- draw single-pack cards (이 페이지에는 더 이상 없지만, 있으면 계속 동작) ---- */
    function drawSkus() {
      var cards = root.querySelectorAll('[data-jb-sku]');
      if (!cards.length) { return; }
      var lines = {};
      Array.prototype.forEach.call(cards, function (c) {
        (c.getAttribute('data-jb-tags') || '').split(' ').forEach(function (t) {
          if (t.indexOf('line-') === 0) { lines[t] = 1; }
        });
        var id = c.getAttribute('data-jb-sku');
        var q = qtyInCart(id);
        var tags = c.getAttribute('data-jb-tags') || '';
        var show = line === 'all' || tags.indexOf(line) !== -1;
        c.classList.toggle('is-hidden', !show);
        c.classList.toggle('is-in', q > 0);
        var ctrl = c.querySelector('[data-jb-skuctrl]');
        ctrl.innerHTML = q
          ? '<div class="jb-scq"><button type="button" data-jb-setqty="' + id + ':' + (q - 1) +
            '">\u2212</button><span class="n">' + q + '</span><button type="button" data-jb-setqty="' +
            id + ':' + (q + 1) + '">+</button></div>'
          : '<button type="button" class="jb-sc__add" data-jb-setqty="' + id + ':1">Add</button>';
      });

      var nav = root.querySelector('[data-jb-lines]');
      if (nav && !nav.childNodes.length) {
        var keys = Object.keys(lines);
        nav.innerHTML = '<button type="button" data-jb-line="all" class="is-on">All</button>' +
          keys.map(function (k) {
            var label = k.replace('line-', '').replace(/\b\w/g, function (m) { return m.toUpperCase(); });
            return '<button type="button" data-jb-line="' + k + '">' + label + '</button>';
          }).join('');
      }
      if (nav) {
        Array.prototype.forEach.call(nav.querySelectorAll('[data-jb-line]'), function (b) {
          b.classList.toggle('is-on', b.getAttribute('data-jb-line') === line);
        });
      }
    }

    /* ---- YOUR BOX 패널(이 페이지에서 제거됨) — DOM 없으면 안전하게 아무것도 안 함 ---- */
    function drawPanel() {
      var panel = root.querySelector('[data-jb-panel]');
      if (!panel) { return; }

      var packs = 0, gross = 0, net = 0, skus = {};
      cart.items.forEach(function (it) {
        var meta = variantMeta[it.variant_id];
        var packsPer = meta ? meta.packs : 1;
        packs += packsPer * it.quantity;
        net += it.final_line_price;
        if (meta && meta.compare > meta.price) {
          gross += meta.compare * it.quantity;
        } else {
          gross += it.final_line_price;
        }
        if (meta && meta.isBox && meta.contents) {
          meta.contents.forEach(function (c) { skus[c.title] = 1; });
        } else {
          skus[it.product_title] = 1;
        }
      });
      var t = { packs: packs, gross: gross, net: net, skus: Object.keys(skus).length };

      var boxes = [], singles = [];
      cart.items.forEach(function (it, i) {
        var meta = variantMeta[it.variant_id];
        var isBox = meta && meta.isBox;
        (isBox ? boxes : singles).push({ item: it, meta: meta, line: i + 1 });
      });

      var html = '';
      if (boxes.length) {
        html += '<p class="jb-pn__cat">Boxes</p>';
        boxes.forEach(function (b) {
          var meta = b.meta || {};
          var off = meta.compare > meta.price ? Math.round((1 - meta.price / meta.compare) * 100) : 0;
          html += '<div class="jb-pb"><div class="jb-pb__t"><b></b><span>' + money(b.item.final_line_price) +
            '</span></div><p class="jb-pb__m">' + (meta.packs || 0) * b.item.quantity + ' packs' +
            (b.item.quantity > 1 ? ' \u00b7 x' + b.item.quantity : '') +
            (off ? ' \u00b7 \u2212' + off + '%' : '') +
            '</p><div class="jb-pb__q"><button type="button" data-jb-setqty="' + b.item.variant_id + ':' + (b.item.quantity - 1) +
            '">\u2212</button><span class="n">' + b.item.quantity + '</span><button type="button" data-jb-setqty="' +
            b.item.variant_id + ':' + (b.item.quantity + 1) + '">+</button></div>' +
            '<button type="button" class="jb-pb__x" data-jb-setqty="' + b.item.variant_id + ':0">Remove</button></div>';
        });
      }
      if (singles.length) {
        html += '<p class="jb-pn__cat">Single packs</p>';
        singles.forEach(function (s) {
          var img = s.item.image;
          html += '<div class="jb-pr">' +
            (img ? '<img src="' + img + '" alt="">' : '<span class="jb-pr__ph"></span>') +
            '<div class="jb-pr__t"><b></b><span>' + money(s.item.final_line_price) + '</span></div>' +
            '<div class="jb-pr__q"><button type="button" data-jb-setqty="' + s.item.variant_id + ':' + (s.item.quantity - 1) +
            '">\u2212</button><span class="n">' + s.item.quantity + '</span><button type="button" data-jb-setqty="' +
            s.item.variant_id + ':' + (s.item.quantity + 1) + '">+</button></div></div>';
        });
      }

      panel.innerHTML = html || '<p class="jb-pn__empty">Empty. Pick a box above, or add any cut.</p>';

      var boxNames = panel.querySelectorAll('.jb-pb__t b');
      boxes.forEach(function (b, i) {
        if (boxNames[i]) { boxNames[i].textContent = (b.meta && b.meta.title) || b.item.product_title; }
      });
      var rowNames = panel.querySelectorAll('.jb-pr__t b');
      singles.forEach(function (s, i) {
        if (rowNames[i]) { rowNames[i].textContent = s.item.product_title; }
      });

      var packsEl = root.querySelector('[data-jb-packs]');
      if (packsEl) { packsEl.textContent = t.packs + (t.packs === 1 ? ' pack' : ' packs'); }
      var skuEl = root.querySelector('[data-jb-skucount]');
      if (skuEl) { skuEl.textContent = t.skus + (t.skus === 1 ? ' SKU' : ' SKUs'); }
      var save = t.gross - t.net;
      var saveEl = root.querySelector('[data-jb-save]');
      if (saveEl) { saveEl.textContent = save > 0 ? 'You save ' + money(save) : ''; }
      var totalEl = root.querySelector('[data-jb-total]');
      if (totalEl) { totalEl.textContent = t.packs ? money(t.net) : '\u2014'; }
      var grossEl = root.querySelector('[data-jb-gross]');
      if (grossEl) { grossEl.textContent = save > 0 ? money(t.gross) : ''; }
      var perpackEl = root.querySelector('[data-jb-perpack]');
      if (perpackEl) { perpackEl.textContent = t.packs ? money(t.net / t.packs) + ' per 4 oz pack' : ''; }

      var gate = root.querySelector('[data-jb-mingate]');
      if (gate) {
        var ok = MIN <= 0 || t.net >= MIN;
        gate.classList.toggle('is-ok', ok);
        var fillEl = root.querySelector('[data-jb-minfill]');
        if (fillEl) { fillEl.style.width = (MIN > 0 ? Math.min(100, t.net / MIN * 100) : 100) + '%'; }
        var mintxtEl = root.querySelector('[data-jb-mintxt]');
        if (mintxtEl) { mintxtEl.textContent = ok ? 'Met \u2014 ships free' : money(t.net) + ' of ' + money(MIN); }

        var say = root.querySelector('[data-jb-minsay]');
        if (say) {
          if (ok) {
            say.textContent = 'Frozen shipping is on us.';
          } else if (t.net === 0) {
            say.textContent = 'Frozen shipping costs us a lot, so orders start at ' + money(MIN) +
              '. Any box clears it on its own.';
          } else {
            say.textContent = money(MIN - t.net) + ' to go';
          }
        }

        var go = root.querySelector('[data-jb-checkout]');
        if (go) {
          go.disabled = t.packs === 0 || !ok;
          if (t.packs === 0) { go.textContent = 'Your box is empty'; }
          else if (!ok) { go.textContent = 'Add ' + money(MIN - t.net) + ' to check out'; }
          else { go.textContent = 'Checkout \u2014 ' + money(t.net); }
        }
      }
    }

    function draw() {
      Array.prototype.forEach.call(root.querySelectorAll('[data-jb-track]'), drawTrack);
      drawSkus();
      drawPanel();
    }

    /* ---- events ---- */
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest || busy) { if (busy) { e.preventDefault(); } return; }

      var v = t.closest('[data-jb-setvar]');
      if (v) {
        v.closest('[data-jb-track]').setAttribute('data-cur-variant', v.getAttribute('data-jb-setvar'));
        draw(); return;
      }
      var sz = t.closest('[data-jb-setsize]');
      if (sz) {
        sz.closest('[data-jb-track]').setAttribute('data-cur-size', sz.getAttribute('data-jb-setsize'));
        draw(); return;
      }
      /* 트랙 Add 버튼은 이제 <form data-jb-boxadd> submit으로 처리(헤더 드로어가 엶) —
         여기서는 별도로 담지 않음. */
      var setq = t.closest('[data-jb-setqty]');
      if (setq) {
        var a = setq.getAttribute('data-jb-setqty').split(':');
        cartSet(a[0], Number(a[1]));
        return;
      }
      var fill = t.closest('[data-jb-fill]');
      if (fill) {
        var fa = fill.getAttribute('data-jb-fill').split(':');
        var have = qtyInCart(fa[0]);
        cartSet(fa[0], have + Number(fa[1]));
        return;
      }
      var ln = t.closest('[data-jb-line]');
      if (ln) { line = ln.getAttribute('data-jb-line'); drawSkus(); return; }

      var go = t.closest('[data-jb-checkout]');
      if (go && !go.disabled) {
        window.location.href = '/checkout';
      }
    });

    /* 박스를 <form data-jb-boxadd>로 담으면(헤더 드로어가 처리) builder 쪽 라벨도 갱신 */
    document.addEventListener('submit', function (e) {
      if (!e.target.closest) { return; }
      var form = e.target.closest('[data-jb-boxadd]');
      if (form && root.contains(form)) {
        setTimeout(function () { fetchCart().then(function () { draw(); syncHeader(); }); }, 500);
      }
    });

    /* the header drawer's Remove buttons also change the cart — re-sync when it does */
    document.addEventListener('click', function (e) {
      if (!e.target.closest) { return; }
      if (e.target.closest('[data-jb-cart-remove]')) {
        /* let the header handler run first, then refresh the builder */
        setTimeout(function () { fetchCart().then(function () { draw(); }); }, 250);
      }
    });

    /* build the variant metadata map, then read the live cart and paint */
    Array.prototype.forEach.call(root.querySelectorAll('[data-jb-track]'), registerTrack);
    Array.prototype.forEach.call(root.querySelectorAll('[data-jb-sku]'), registerSku);
    fetchCart().then(function () { draw(); syncHeader(); });
  }

  /* ── 7. box picker — mobile swipe dots ────────────────────────────────── */
  function initBoxDots() {
    var rail = document.querySelector('[data-jb-bgrid]');
    var dots = document.querySelector('[data-jb-bdots]');
    if (!rail || !dots) { return; }

    var cards = rail.querySelectorAll('.jb-box');
    if (cards.length < 2) { return; }

    dots.innerHTML = '';
    Array.prototype.forEach.call(cards, function (c, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Box ' + (i + 1));
      b.addEventListener('click', function () {
        rail.scrollTo({ left: c.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
      });
      dots.appendChild(b);
    });

    var buttons = dots.querySelectorAll('button');

    function sync() {
      var mid = rail.scrollLeft + rail.clientWidth / 2;
      var best = 0, bestGap = Infinity;
      Array.prototype.forEach.call(cards, function (c, i) {
        var centre = c.offsetLeft - rail.offsetLeft + c.offsetWidth / 2;
        var gap = Math.abs(centre - mid);
        if (gap < bestGap) { bestGap = gap; best = i; }
      });
      Array.prototype.forEach.call(buttons, function (b, i) {
        b.classList.toggle('is-on', i === best);
      });
    }

    rail.addEventListener('scroll', sync, { passive: true });
    sync();
  }

  ready(function () {
    initRails();
    initFilters();
    initProduct();
    initCart();
    initHeader();
    initBuilder();
    initBoxDots();
  });
}());
